(function () {
  "use strict";

  // ----------------------------------------------------------------------------------------------------------------
  // COLLECTION/HOME PAGE CART DRAWER SUPPRESSION
  // ----------------------------------------------------------------------------------------------------------------
  //
  // This theme's CartDrawer.onCartChange_fn (assets/theme.js) opens the drawer unconditionally
  // for every add-to-cart — it has no concept of "where did this add come from" at all (unlike
  // the sibling theme, this one never got a data-atc-source/collection_page mechanism added).
  // Since a shopper is only ever on ONE page at a time, gating on the page's own template is both
  // simpler and just as correct as tracking the individual click would be: if the milestone bar is
  // actually enabled on THIS page (window.__milestoneBarEnabledHere, set in layout/theme.liquid
  // from the per-page "Enable on home/collection/product pages" theme settings, plus the "Enable
  // everywhere except product" global override), any drawer-open caused by an add-to-cart should
  // be suppressed in favor of the milestone-cart-toast.liquid bar updating instead. When the bar is
  // OFF for this page (merchant disabled it here specifically), the drawer opens normally instead
  // — there's no toast to substitute for it. Manual opens (the header cart icon, or the milestone
  // bar's own Cart button) must keep working normally — those don't go through cart:change at all.
  //
  // Gokwik's own SDK also auto-opens its sidecart independently on add-to-cart, regardless of
  // page. That auto-open (not a manual click) is what this suppresses here.
  //
  // IMPORTANT: the Gokwik-closing watcher below is only armed for a short window right after a
  // real add-to-cart event. It used to run as an unconditional interval that closed ANY sidecart
  // mount for any reason — which meant a shopper manually clicking the header icon or the
  // milestone bar's Cart button to view their cart had it slammed shut within ~100ms, before it
  // was even visible. Scoping the watcher to only fire in reaction to a genuine add fixes that
  // while still suppressing Gokwik's unwanted auto-open-on-add behavior here.
  //
  // The product-card quick-add button's request gets intercepted by bundle-cart-sync.liquid's
  // patched fetch/XHR before the theme's own ProductForm.onSubmit_fn ever runs, so the theme's
  // native cart:change ("baseEvent":"variant:add") never actually fires for this flow — only
  // bundle-cart-sync's own "cart:refresh" event does (no detail shape to filter on, but on a
  // collection/home page any cart mutation reaching here is effectively an add).

  // Scoped to collection/home only — product pages have their own separate drawer handling
  // (assets/pdp-native-drawer-gate.js) that this must not interfere with, regardless of whether
  // the milestone bar happens to be enabled on product pages too.
  var isCollectionOrHome =
    document.body.classList.contains("template-collection") ||
    document.body.classList.contains("template-index");

  if (!isCollectionOrHome || !window.__milestoneBarEnabledHere) return;

  var ADD_TRIGGERED_WATCH_MS = 3000;

  // cart-drawer-gate.js's own fallback paths (header-cart-icon-fallback.js, pdp-native-drawer-gate.js)
  // deliberately force-release the gate and open the native drawer for real when Gokwik's sidecart
  // has failed to mount — a documented, known Gokwik-side failure mode on this store. Without this
  // check, this script closed that drawer right back on the very same cart:change/cart:refresh
  // event that triggered it, leaving the shopper with NO cart UI at all instead of the intended
  // "wrong but visible" native fallback. Only suppress while the gate is still actively gating (or
  // Gokwik is confirmed ready) — never fight a fallback that already gave up on Gokwik for good.
  function isGokwikPermanentlyUnavailable() {
    if (!window.__zkCartGate || typeof window.__zkCartGate.status !== "function") return false;
    var status = window.__zkCartGate.status();
    return status.state === "released" && !status.readinessObserved;
  }

  document.addEventListener("cart:change", function (event) {
    if (!event.detail || event.detail.baseEvent !== "variant:add") return;
    if (isGokwikPermanentlyUnavailable()) return;

    // By the time this listener runs, CartDrawer's own cart:change listener (attached earlier,
    // when the custom element first connected) has already called .show() — close it right back.
    var drawer = document.querySelector("cart-drawer");
    if (drawer && typeof drawer.hide === "function" && drawer.hasAttribute("open")) {
      drawer.hide();
    }

    armGokwikCloseWatch();
  });

  document.addEventListener("cart:refresh", function () {
    if (isGokwikPermanentlyUnavailable()) return;

    var drawer = document.querySelector("cart-drawer");
    if (drawer && typeof drawer.hide === "function" && drawer.hasAttribute("open")) {
      drawer.hide();
    }

    armGokwikCloseWatch();
  });

  function getShadowRoot() {
    var container = document.querySelector("shadow-dom-container");
    return container ? container.shadowRoot : null;
  }

  function sidecartMounted() {
    var sr = getShadowRoot();
    return sr ? !!sr.querySelector(".sidecart") : false;
  }

  function armGokwikCloseWatch() {
    var wasMounted = sidecartMounted();
    var elapsed = 0;
    var pollId = setInterval(function () {
      elapsed += 100;
      var isMounted = sidecartMounted();
      if (isMounted && !wasMounted) {
        window.closeGokwikSideCart?.();
        clearInterval(pollId);
        return;
      }
      wasMounted = isMounted;
      if (elapsed >= ADD_TRIGGERED_WATCH_MS) clearInterval(pollId);
    }, 100);
  }
})();
